import './import';
import '../css/index.css'
import 'pixi-spine';
import { createStore } from 'redux';
import reducer from './redux/reducers';
import StoreObserver from './redux/storeObserver';
import Game from './controllers/controllerGame';
import ControllerPopupRulesHTML from './controllers/popups/popupRulesHTML';
import ControllerPopupBigWinHTML from './controllers/popups/popupBigWinHTML';
import '../../submoduleConfigs';
import 'Preloader/preloader';

export const store = createStore(reducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());

export const storeObserver = new StoreObserver(store);

new ControllerPopupRulesHTML();
new ControllerPopupBigWinHTML();

new Game();
